//ORDINI DI SPEDIZIONE
export const FETCH_ORDINI_DATA_SUCCESS = "FETCH_ORDINI_DATA_SUCCESS";
export const CHANGE_FILTER_ORDINI = "CHANGE_FILTER_ORDINI";
export const SET_SELECTED_TABLE_ROW = "SET_SELECTED_TABLE_ROW";
export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const SET_SORTING_ORDINI = "SET_SORTING_ORDINI";
export const SET_LOADING_ORDINI = "SET_LOADING_ORDINI";
export const SET_ORDINI_FILTER_SUGGESTION_DATA = "SET_ORDINI_FILTER_SUGGESTION_DATA";
export const SET_ORDINI_SUGGESTION_LOADING = "SET_ORDINI_SUGGESTION_LOADING";


//SIM
export const FETCH_SIM_DATA_SUCCESS = "FETCH_SIM_DATA_SUCCESS";
export const FETCH_SIM_START = "FETCH_SIM_START";
export const FETCH_SIM_ERROR = "FETCH_SIM_ERROR";
export const CHANGE_FILTER_SIM = "CHANGE_FILTER_SIM";
export const RESET_FILTER_SIM = "RESET_FILTER_SIM";
export const SET_FILTER_CLICKED = "SET_FILTER_CLICKED";
export const SIM_SET_SELECTED_TAB = "SIM_SET_SELECTED_TAB";
export const SIM_SET_SELECTED_TABLE_ROW = "SIM_SET_SELECTED_TABLE_ROW";
export const SIM_SET_DASHBOARD = "SIM_SET_DASHBOARD";
export const SET_SORTING_SIM = "SET_SORTING_SIM";
export const SET_LOADING_SIM = "SET_LOADING_SIM";
export const SET_ALL_SELECTED_ATTIVE_LOADNIG = "SET_ALL_SELECTED_ATTIVE_LOADNIG";
export const SET_WRENCH_LOADING_ATTIVE = "SET_WRENCH_LOADING_ATTIVE";
export const SET_WRENCH_DETAILS_ATTIVE = "SET_WRENCH_DETAILS_ATTIVE";
export const SET_WRENCH_DETAILS_IN_ATTIVAZIONE = "SET_WRENCH_DETAILS_IN_ATTIVAZIONE";
export const SET_SIM_FILTER_LOADING_OR_ERROR = "SET_SIM_FILTER_LOADING_OR_ERROR";
export const SET_SIM_FILTER_INPUT_DATA = "SET_SIM_FILTER_INPUT_DATA";
export const FETCH_NUMBERS_BLOCKED_LIST = "FETCH_NUMBERS_BLOCKED_LIST";
export const SET_LOADING_NUMBERS_BLOCKED_LIST = "SET_LOADING_NUMBERS_BLOCKED_LIST";
export const HANDLE_NUMBER_BLOCKED_LIST_CHANGE = "HANDLE_NUMBER_BLOCKED_LIST_CHANGE";
export const CLEAR_NUMBER_BLOCKED_LIST = "CLEAR_NUMBER_BLOCKED_LIST";
export const SET_SIM_FILTER_SUGGESTION_DATA = "SET_SIM_FILTER_SUGGESTION_DATA";
export const SET_SIM_SUGGESTION_LOADING = "SET_SIM_SUGGESTION_LOADING";
export const UPDATE_CHANGED_TAGS_SIM = "UPDATE_CHANGED_TAGS_SIM";
export const UPDATE_CHANGED_TAGS_DEVICE = "UPDATE_CHANGED_TAGS_DEVICE";
export const SET_ACTIVE_SERVICE_REQUEST = "SET_ACTIVE_SERVICE_REQUEST";
export const UPDATE_SIM_TAGS_AUTOCOMPLETE_SUCCESS = "UPDATE_SIM_TAGS_AUTOCOMPLETE_SUCCESS";
export const FETCH_BULK_LIST_ASSOCIATED_TO_SIM = "FETCH_BULK_LIST_ASSOCIATED_TO_SIM";
export const SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM = "SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM";
export const SET_LOADING_COLLABORATORS_SIM = "SET_LOADING_COLLABORATORS_SIM";
export const SET_ERROR_COLLABORATORS_SIM = "SET_ERROR_COLLABORATORS_SIM";
export const GET_COLLABORATORS_SIM = "GET_COLLABORATORS_SIM";
export const SET_LOADING_OR_ERROR_SIM_DETAILS = "SET_LOADING_OR_ERROR_SIM_DETAILS"
export const SET_SIM_DETAILS = "SET_SIM_DETAILS"
export const CHANGE_AUTOCOMPLETE_LIST_FOR_SELECTED_SIM = "CHANGE_AUTOCOMPLETE_LIST_FOR_SELECTED_SIM";
export const FETCH_SIM_GROUP_COUNT_SUCCESS = "FETCH_SIM_GROUP_COUNT_SUCCESS"
export const SET_SIM_GROUP_COUNT_LOADING = "SET_SIM_GROUP_COUNT_LOADING"
export const SET_SIM_RESET_PASSWORD_VALUES = "SET_SIM_RESET_PASSWORD_VALUES"
export const SET_SIM_CSV_DOWNLOAD_LOADING = "SET_SIM_CSV_DOWNLOAD_LOADING"
export const FETCH_SIMS_TO_BE_RECHARGED = "FETCH_SIMS_TO_BE_RECHARGED_DATA_AND_LOADING"
export const ADD_RECHARGE_PROPERTIES = "ADD_RECHARGE_PROPERTIES"

//AUTH
export const SET_LOGIN_PARAMS = "SET_LOGIN_PARAMS";
export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const SET_FILTER_COMPANIES = "SET_FILTER_COMPANIES";
export const SAML_LOGOUT = "SAML_LOGOUT";
export const SET_LOADING_AUTH = "SET_LOADING_AUTH";
export const GET_CONTACT_NUMBERS_FOR_CUSTOMER = "GET_CONTACT_NUMBERS_FOR_CUSTOMER";
export const CLEAR_CONTACT_NUMBERS = "CLEAR_CONTACT_NUMBERS";
export const SET_LOADING_CONTACT_NUMBERS = "SET_LOADING_CONTACT_NUMBERS";
export const LOGOUT_USER = "LOGOUT_USER";
export const EXPAND_MOBILE_MENU = "EXPAND_MOBILE_MENU";
export const CACHE_SIMS_LOADING = "CACHE_SIMS_LOADING"
export const CACHE_DIGITAL_CONTRACT_LOADING = "CACHE_DIGITAL_CONTRACT_LOADING"

//Service Requests
export const GET_CATEGORIES_AND_REFERENTE_IN_SEGNALAZIONE = "GET_CATEGORIES_AND_REFERENTE_IN_SEGNALAZIONE";
export const GET_CATEGORIES_IN_SEGNALAZIONE = "GET_CATEGORIES_IN_SEGNALAZIONE";
export const GET_AREAS_IN_SEGNALAZIONE = "GET_AREAS_IN_SEGNALAZIONE";
export const GET_DETTAGLIO_IN_SEGNALAZIONE = "GET_DETTAGLIO_IN_SEGNALAZIONE";
export const CLEAR_SEGNALAZIONE = "CLEAR_SEGNALAZIONE";
export const GET_OPERATORS = "GET_OPERATORS";
export const CLEAR_OPERATORS = "CLEAR_OPERATORS";
export const CREATE_TAG_SELECTED_ITEMS = "CREATE_TAG_SELECTED_ITEMS";
export const GET_ADDRESS_FOR_CUSTOMER = "GET_ADDRESS_FOR_CUSTOMER";
export const CLEAR_CUSTOMER_ADDRESS = "CLEAR_CUSTOMER_ADDRESS";
export const UPDATE_CREDIT = "UPDATE_CREDIT";
export const UPDATE_THRESHOLD = "UPDATE_THRESHOLD";
export const SET_LOADING_GET_ADDRESS_FOR_CUSTOMER = "SET_LOADING_GET_ADDRESS_FOR_CUSTOMER";
export const SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM = "SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM";
export const ADD_NEW_REFERENTE = "ADD_NEW_REFERENTE";
export const SET_TAGS_FOR_SELECTED_ITEMS = "GET_TAGS_FOR_SELECTED_ITEMS";
export const LOADING_TAGS_SELECTED_ITEMS = "LOADING_TAGS_SELECTED_ITEMS";
export const SET_LOADING_GESTISCI_TAG = "SET_LOADING_GESTISCI_TAG";
export const SET_SIM_SOSTITUVE = "SET_SIM_SOSTITUVE";
export const SET_MODIFY_ABILITAZIONE_DATI_PARAMS = "SET_MODIFY_ABILITAZIONE_DATI_PARAMS";
export const GET_E_SIM_QR_AND_LOADING = "GET_E_SIM_QR_AND_LOADING";
export const SET_LOADING_SUSPENSION_SIMS = "SET_LOADING_SUSPENSION_SIMS"

//REPORT
export const REPORT_SET_SELECTED_TAB = "REPORT_SET_SELECTED_TAB";
export const SET_REPORT_LINKS = "SET_REPORT_LINKS";
export const SET_SINGLOA_MSISDN = "SET_SINGLOA_MSISDN";
export const SET_BULK_GROUP_KEY_REPORT = "SET_BULK_GROUP_KEY_REPORT";

//RICHIESTE ASSISTENZA
export const ASSISTENZA_SET_SELECTED_TAB = "ASSISTENZA_SET_SELECTED_TAB";
export const SET_LOADING_ASSISTENZA = "SET_LOADING_ASSISTENZA";
export const FETCH_ASSISTENZA_DATA_SUCCESS = "FETCH_ASSISTENZA_DATA_SUCCESS";
export const SET_SORTING_RICHIESTA = "SET_SORTING_RICHIESTA";
export const CHANGE_TAGS_DEVICE = "CHANGE_TAGS_DEVICE";
export const DELETE_TAG_DEVICE = "DELETE_TAGS_DEVICE";
export const CREATE_TAG_SIM = "CREATE_TAG_SIM";
export const DELETE_TAG_SIM = "DELETE_TAG_SIM";
export const EDIT_TAG_SIM = "EDIT_TAG_SIM";
export const EDIT_TAG_DEVICE = "EDIT_TAG_DEVICE";
export const CREATE_TAG_DEVICE = "CREATE_TAG_DEVICE";
export const SET_ASSISTENZA_FILTER_SUGGESTION_DATA = "SET_ASSISTENZA_FILTER_SUGGESTION_DATA";
export const SET_ASSISTENZA_SUGGESTION_LOADING = "SET_ASSISTENZA_SUGGESTION_LOADING";

//DEVICE
export const SET_LOADING_DEVICES = "SET_LOADING_DEVICES";
export const SET_LOADING_DEVICE_DETAILS = "SET_LOADING_DEVICE_DETAILS";
export const GET_DEVICES = "GET_DEVICES";
export const SET_SELECTED_DEVICE = "SET_SELECTED_DEVICE";
export const SET_SORTING_DEVICE = "SET_SORTING_DEVICE";
export const CHANGE_FILTER_DEVICE = "CHANGE_FILTER_DEVICE";
export const RESET_FILTER_DEVICE = "RESET_FILTER_DEVICE";
export const SET_FILTER_CLICKED_DEVICE = "SET_FILTER_CLICKED_DEVICE";
export const SET_DEVICE_FILTER_LOADING_OR_ERROR = "SET_DEVICE_FILTER_LOADING_OR_ERROR";
export const SET_DEVICE_FILTER_INPUT_DATA = "SET_DEVICE_FILTER_INPUT_DATA";
export const UPDATE_MODELLO_SELECT = "UPDATE_MODELLO_SELECT";
export const SET_DEVICE_FILTER_SUGGESTION_DATA = "SET_DEVICE_FILTER_SUGGESTION_DATA";
export const SET_DEVICE_SUGGESTION_LOADING = "SET_DEVICE_SUGGESTION_LOADING";
export const SET_WRENCH_LOADING_DEVICES = "SET_WRENCH_LOADING_DEVICES";
export const SET_WRENCH_DETAILS_DEVICE = "SET_WRENCH_DETAILS_DEVICE";
export const SET_ACTIVE_DEVICE_SERVICE_REQUEST = "SET_ACTIVE_DEVICE_SERVICE_REQUEST";
export const SET_LOADING_COLLABORATORS_DEVICE = "SET_LOADING_COLLABORATORS_DEVICE";
export const GET_COLLABORATORS_DEVICE = "GET_COLLABORATORS_DEVICE";
export const SET_ERROR_COLLABORATORS_DEVICE = "SET_ERROR_COLLABORATORS_DEVICE";
export const CLEAR_SELECTED_ROW_DEVICE = "CLEAR_SELECTED_ROW_DEVICE";
export const UPDATE_DEVICE_TAGS_AUTOCOMPLETE_SUCCESS = "UPDATE_DEVICE_TAGS_AUTOCOMPLETE_SUCCESS";
export const SET_DEVICE_CSV_DOWNLOAD_LOADING = "SET_DEVICE_CSV_DOWNLOAD_LOADING"
export const SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM = "DEVICE_ASSOCIAZIONE_KASKO_CUSTOM"
export const SET_DEVICE_ASSOCIAZIONE_NOT_KASKO_CUSTOM = "SET_DEVICE_ASSOCIAZIONE_NOT_KASKO_CUSTOM"
export const SET_DEVICE_ASSOCIAZIONE_LOADING = "SET_DEVICE_ASSOCIAZIONE_LOADING"

// SOM
export const SET_ENABLING_CLASSES = "SET_ENABLING_CLASSES";
export const CLEAR_ENABLING_CLASSES = "CLEAR_ENABLING_CLASSES";
export const SET_LOADING_ENABLING_CLASSES = "SET_LOADING_ENABLING_CLASSES";
export const CHANGE_SELECTED_ENABLED_CLASS = "CHANGE_SELECTED_ENABLED_CLASS";
export const SET_LOADING_ENABLING_DATA = "SET_LOADING_ENABLING_DATA";
export const SET_ENABLING_DATA = "SET_ENABLING_DATA";
export const CHANGE_SELECTED_ENABLED_DATA = "CHANGE_SELECTED_ENABLED_DATA";
export const CLEAR_ENABLING_DATA = "CLEAR_ENABLING_DATA";
export const SET_CHANGE_IP_VALUES = "SET_CHANGE_IP_VALUES";
export const SET_CHANGE_APN_VALUES = "SET_CHANGE_APN_VALUES";
export const SET_CHANGE_APN_SELECT_DATA = "SET_CHANGE_APN_SELECT_DATA";
export const SET_CHANGE_RAM_PARAMS = "SET_CHANGE_RAM_PARAMS";

//DIGITAL CONTRACT
export const GET_BULK_CARD_DATA = "GET_BULK_CARD_DATA";
export const FETCH_PLAN_OPTIONS_FOR_SIM = "FETCH_PLAN_OPTIONS_FOR_SIM";
export const SET_LOADING_PLAN_OPTIONS_FOR_SIM = "SET_LOADING_PLAN_OPTIONS_FOR_SIM";
export const FETCH_OFFER_FOR_NEW_PLAN = "FETCH_OFFER_FOR_NEW_PLAN";
export const SET_LOADING_OFFER_FOR_NEW_PLAN = "SET_LOADING_OFFER_FOR_NEW_PLAN";
export const SET_LOADING_BULK_CARDS = "SET_LOADING_BULK_CARDS";
export const SET_BULK_DETAILS_CONTENT = "SET_BULK_DETAILS_CONTENT";
export const SET_BULK_DETAILS_ASSOCIATED_SIMS = "SET_BULK_DETAILS_ASSOCIATED_SIMS";
export const SET_BULK_DETAILS_OFFER = "SET_BULK_DETAILS_OFFER";
export const SET_LOADING_BULK_DETAILS = "SET_LOADING_BULK_DETAILS";
export const FETCH_BULK_DETAILS_NOT_ASSOCIATED_SIMS = "FETCH_BULK_DETAILS_NOT_ASSOCIATED_SIMS";
export const SET_BULK_DETAILS_ACTION_LOADING = "SET_BULK_DETAILS_ACTION_LOADING";
export const FETCH_ADD_REMOVE_OPTIONS = "FETCH_ADD_REMOVE_OPTIONS";
export const SET_LOADING_ADD_REMOVE_OPTIONS = "SET_LOADING_ADD_REMOVE_OPTIONS";
export const SET_SELECTED_TAB_EXTRA_SHARE = "SET_SELECTED_TAB_EXTRA_SHARE";
export const UPDATE_SIM_ASSOCIATE_BULK = "UPDATE_SIM_ASSOCIATE_BULK";
export const SET_BULK_CSV_DOWNLOAD_LOADING = "SET_BULK_CSV_DOWNLOAD_LOADING"

//ESIM ACTION
export const DISTRIBUZIONE_DIGITALE = "DISTRIBUZIONE_DIGITALE"

